import getUserInfo from '@/fetches/user/user-profile/get-user-profile';
import { actions, AppStore } from '@/store';
import TokenManager from './token-manager';

export const updateUserInfo = async () => {
  const { dispatch } = AppStore;
  const userInfo = await getUserInfo();
  if (userInfo) {
    dispatch(actions.common.userInfo.setProfile(userInfo));
  } else {
    TokenManager.removeToken();
    dispatch(actions.common.userInfo.initProfile());
  }
};
